import { faMinus, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import "./IncrementDecrementBtn.css";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCart,
  postCartQuantity,
} from "../../../../features/cart/cartSlice";
import { variant_type } from "../../../../utils/common";

const IncrementDecrementBtn = ({
  quantity,
  setQuantity,
  val,
  product,
  selectedVariant,
}) => {
  // const [quantity, setQuantity] = useState(1);
  const [Errors, setErrors] = useState();
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart.allCarts);
  const isSignIn = useSelector((state) => state.auth.is_signin);

  const increment = () => {
    setQuantity((prev) => prev + 1);
  };

  const decrement = () => {
    setQuantity((prev) => (prev > 1 ? prev - 1 : 1));
  };

  const cartQuantity = async (type) => {
    try {
      // if(type === "add" &&Number(val?.quantity) >= Number(val?.Product_Variant?.general_stock)){
      //   setInstock(true);
      //   return
      // }
      const data = {
        cart_id: val?.id,
        type: type,
        isSignIn,
        product_id: val.product_id,
        variant_id: val.variant_id,
        d_variant_id: val.d_variant_id,
        t_variant_id: val.t_variant_id,
        variant_type_id: val.Product.variant_type_id,
      };
      const res = await dispatch(postCartQuantity(data));
      if (res.meta?.requestStatus === "fulfilled") {
        dispatch(getAllCart(isSignIn));
      } else if (res.meta?.requestStatus === "rejected") {
        // console.log("Error:", res.payload || "Not In Cart");
      }
    } catch (error) {
      // console.log("Error:", error);
    }
  };

  const matchedCartItem = cart?.data?.find((cart) => {
    console.log(cart.product_id, "cart.product_id cart.product_id");
    console.log(product?.variant_type_id, "variant_type_id?.id product?.id");
    console.log(selectedVariant, "selectedVariant selectedVariant");

    // Product must match
    if (Number(cart.product_id) !== Number(product?.id)) return false;

    // Variant match according to product_type_id
    if (product?.variant_type_id === variant_type.Single) {
      return cart.variant_id === selectedVariant?.id;
    }

    if (product?.variant_type_id === variant_type.Double) {
      return cart.d_variant_id === selectedVariant?.id;
    }

    if (product?.variant_type_id === variant_type.Triple) {
      return cart.t_variant_id === selectedVariant?.id;
    }
  });

  useEffect(() => {
    setQuantity(matchedCartItem?.quantity || 1);
  }, [matchedCartItem]);

  return (
    <div className="Increment_Decrement_Btn">
      <div className={`main_content_holder`}>
        {/* Decrement Button */}
        <div className="icon_holder" onClick={decrement}>
          <FontAwesomeIcon icon={faMinus} className="icon_class" />
        </div>

        <div className="count_holder p-2">
          <p className="count">{Number(quantity) || 1}</p>
        </div>

        <div className="icon_holder" onClick={increment}>
          <FontAwesomeIcon icon={faPlus} className="icon_class" />
        </div>
      </div>
      {Errors && <p style={{ color: "red" }}>{Errors}</p>}
    </div>
  );
};

export default IncrementDecrementBtn;
